export const getUrlParameter = (paramName: string): string | null => {
  if (typeof window !== 'undefined') {
    try {
      return new URLSearchParams(window.location.search).get(paramName);
    } catch (error) {
      console.warn('Failed to get URL parameter:', error);
      return null;
    }
  }
  return null;
};
